import type { GetTreasuryBankAccountsParams } from '../types/treasuryAccountsTypes'

export const treasuryAccountKeys = {
  all: ['treasury', 'bankAccounts'] as const,

  lists: () => [...treasuryAccountKeys.all, 'list'] as const,
  list: (filters: GetTreasuryBankAccountsParams) =>
    [...treasuryAccountKeys.lists(), filters] as const,
}
